//do not import things that require SDK files directly here or Sdk overrides will not work
import React from 'react'
import { createRoot, Root } from 'react-dom/client'
import '@fortawesome/fontawesome-free/css/all.css'
import '@style/main.scss'
import 'moment/dist/locale/en-gb'
import 'moment/dist/locale/it'
import 'moment/dist/locale/es'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/de'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/ca'
import 'moment/dist/locale/pt'
import 'dayjs/locale/it'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/nl'
import 'dayjs/locale/ca'
import './index.css'
import {
  getBestLang,
  getMomentLocale,
  setCurrentLang,
} from '@criptalia/sdk/src/utils/translatorUtils'
import externalRedirect from '@components/ExternalRedirect'
import parseReferralCookies from '@components/ReferralCookie'
import { Sdk, SdkConfig } from '@criptalia/sdk/src/Sdk'
// @ts-ignore
import moment from 'moment'
import { FRONTEND_ENV } from '@src/env'


const App = React.lazy(() => import('@src/App'))

// Before Sdk.init getBestLang only knows the SDK default languages (no fr):
// it is resolved again below, once the October list is configured.
let lang = getBestLang()
moment.locale(getMomentLocale(lang))

//required for criptalia-sdk to work - override here for SaaS
Sdk.init({
  env: FRONTEND_ENV,
  variables: {
    lang: {
      // October users are mostly French: fr first (default when the browser
      // language is none of these)
      dev: ['fr', 'en', 'it', 'es', 'de', 'nl', 'ca', 'pt'],
      prod: ['fr', 'en', 'it', 'es', 'de', 'nl', 'ca', 'pt'],
    },
  },
  api: {
    baseUrl: import.meta.env.PROD ? import.meta.env.VITE_API_URL : '/',
    paymentProvider: 'lemonway',
    scaEnabled: false, // SCA not yet activated in Lemonway
  },
} as Partial<SdkConfig>).then(() => {
    lang = getBestLang()
    moment.locale(getMomentLocale(lang))
    const container = document.getElementById('root')
    const root: Root = createRoot(container)
    root.render(<App />)
})

/*
When React renders, some events happen that may even redirect the user to an
external website. This means that, before even starting react, we need to check
cookies and language.
*/
function checkRedirects(): boolean {
  let redirectUrl: string = ''

  const refUrl: string = parseReferralCookies(redirectUrl)
  if (refUrl) {
    redirectUrl = refUrl
  }

  const langUrl = setCurrentLang(lang, redirectUrl)
  if (langUrl) {
    redirectUrl = langUrl
  }

  const externalUrl = externalRedirect(lang, redirectUrl)
  if (externalUrl) {
    redirectUrl = externalUrl
  }

  if (redirectUrl === window.location.href) {
    window.location.reload()
  } else {
    window.location.replace(redirectUrl)
  }
  
  return true
}
